import * as React from 'react';
import { Text } from '@lightspeed/flame/Text';

interface ReceiptItemDescriptionProps {
  description?: string;
  tax: boolean;
  hasUntaxedItems: boolean;
  lineNumber: number;
  isGroupedItem: boolean;
}

const ReceiptItemDescription: React.FunctionComponent<ReceiptItemDescriptionProps> = ({
  lineNumber,
  description,
  hasUntaxedItems,
  tax,
}) => {
  if (!description) return null;

  const descriptionLines = description.split('\n');

  return (
    <>
      {descriptionLines.map((descriptionLine, index) => (
        <Text
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          lineHeight="normal"
          size="large"
          color="gray-800"
          data-testid={`saleLine-${lineNumber}-item-description`}
        >
          {descriptionLine}
          {hasUntaxedItems && !tax && !index ? ' *' : ''}
        </Text>
      ))}
    </>
  );
};

export { ReceiptItemDescription };
